import c from 'classnames';

import s from './HoverMagic.module.scss';
import { useRef } from 'react';
import { useIsTouchDevice } from 'hooks/useIsTouchDevice';
import { HeadingTags } from 'types/html-types';

type HoverMagicProps = {
  as?: HeadingTags;
  className?: string;
  style?: React.CSSProperties;
  skipGradient?: boolean;
  type?: HeadingTags;
  children: React.ReactNode;
};

export const HoverMagic = ({
  as,
  children,
  className,
  style,
  skipGradient = false,
  type = 'h1',
}: HoverMagicProps) => {
  const ref = useRef<HTMLHeadingElement>(null);
  const isTouchDevice = useIsTouchDevice();

  if (!children) {
    return null;
  }

  const Wrap = as ?? type;

  const handleMouseMove = (e: React.MouseEvent<HTMLSpanElement>) => {
    if (isTouchDevice) {
      return;
    }

    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();

    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    ref.current?.style.setProperty('--x', `${x}%`);
    ref.current?.style.setProperty('--y', `${y}%`);
  };

  return (
    <Wrap
      ref={ref}
      className={c(className, { [s.gradientTitle]: !skipGradient })}
      style={style}
      onMouseMove={handleMouseMove}
    >
      {children}
    </Wrap>
  );
};
